module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAPxJREFUaEPtmdENwjAMRO82YARGYQRGgBGYhBHoCIzAKIzQDYyCBCoqH3XT1El1lvpTOXZyL2rshmjc2Pj8oQVEE9wOATM7ArhGKzox/4XkPfl+CZjZCcBtYoBotzPJTgsIxPCXwB7AIXBSntQPks+fLeQZXZPvdj6jNanqmYsIeNQq4SsCJVT1xBQBj1olfEWghKqemMNyegcgPdXbpw5SOR2ISg1NoPjv1GMC6a2ZpaamBetJ9mpoakClkziaggiIQKYC2kKZAmYPF4FsCTMDDBuaVAelO4IWrBv93NUFx7rcttnQtH3Jt+4OWC6bzoHltJwXSQTm6bbcqBc8K08xmspLoQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/menu.png
// module id = Hosi
// module chunks = 0